import { AutoMarkType } from "services/shortAnswerService/question-types/common";
import { AnyQuestionI } from "services/shortAnswerService/question-types/Question";
import { isTextQuestion } from "services/shortAnswerService/question-types/typeGuards";

export function getTagTone(mark: number, marksTotal: number) {
  if (marksTotal === 0) {
    return "error";
  }
  const percent = mark / marksTotal;
  if (percent === 0) return "error";
  else if (percent > 0 && percent < 1) return "warning";
  else return "success";
}

export function getIsAutoMarkingAvailable({
  autoMarkingEnabled,
  question
}: {
  autoMarkingEnabled: boolean;
  question?: AnyQuestionI;
}) {
  return !!question && autoMarkingEnabled && questionHasAutoMarking(question);
}

export function questionHasAutoMarking(question: AnyQuestionI) {
  return (
    isTextQuestion(question) && question.autoMarkType !== AutoMarkType.NONE
  );
}

export function getActualMark(questionStats?: {
  teacherMark?: number;
  selfMark?: number;
  mark?: number;
}) {
  return (
    questionStats?.teacherMark ?? questionStats?.selfMark ?? questionStats?.mark
  );
}
